import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { TablePagination, Modal, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  confirmDeliveryDwo,
  dwo_fullfillment,
  precurement_completed,
  precurement_initialize,
  precurement_status,
  precurementInitialization,
  fundMasterSubType,
  fundMasterType,
} from "../api/Users";
import { toast } from "react-toastify";
import { logDOM } from "@testing-library/react";

const Fulfillment = ({ userData }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [newModal, setnewModal] = useState(false);
  const [newModal1, setnewModal1] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [invoiceData, setInvoiceData] = useState({
    fundType: "",
    fundSubType: "",
    quantity: "",
    amount: "",
    deliveryDate: "",
    initializeDate: "",
    confirm_delivery_dwo: "",
    invoiceNumber: "",
    GST: "",
    total: "",
    requirement_id: "",
    amenities_id: "",
    amenities_sub_type_id: "",
    school_id: "",
    procurement: "",
    upload_confirmed_delivery_asset_photo_dwo: "",
  });
  const [fundTypes, setFundTypes] = useState([]);
  const [fundSubTypes, setFundSubTypes] = useState([]);
  const [fundType, setFundType] = useState([]);
  const [fundSubType, setFundSubType] = useState([]);
  const [isShortage, setIsShortage] = useState(0);

  const fetchfulfillment = async () => {
    setIsLoading(true);
    const data = {
      district_code: userData.data.district_code,
    };
    const fulfillmentData = await dwo_fullfillment(data);
    if (fulfillmentData.status == "success") {
      setFilteredData(fulfillmentData.data.result);

      setIsLoading(false);
    } else {
      setFilteredData([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchfulfillment();
    fundMasterType()
      .then((response) => {
        if (response.status === "success") {
          setFundTypes(response.data);
        } else {
          setFundTypes([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching fund types:", error);
        setFundTypes([]);
      });

    fundMasterSubType()
      .then((response) => {
        if (response.status === "success") {
          setFundSubTypes(response.data);
        } else {
          setFundSubTypes([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching fund types:", error);
        setFundSubTypes([]);
      });
  }, []);

  const handleInvoice = (e) => {
    const { name, value, type, files } = e.target;

    if (type !== "file") {
      setInvoiceData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      const file = files[0];
      setInvoiceData((prevState) => ({ ...prevState, [name]: file }));
    }

    if (name === "amount" || name === "GST") {
      const actual_amount =
        name === "amount" ? parseInt(value) : parseInt(invoiceData.amount);
      const gst = name === "GST" ? parseInt(value) : parseInt(invoiceData.GST);
      const gstAmount = actual_amount * (gst / 100);

      const totalAmount = actual_amount + gstAmount;

      setInvoiceData((prevState) => ({
        ...prevState,
        total: totalAmount.toFixed(2),
      }));
    }
  };

  const handleProcurementStatusChange = async (row, status) => {
    if (status == 1) {
      setnewModal1(true);
      // const statusData = await precurement_initialize({
      //   requirement_id: row.req_id,
      //   school_id: row.school_id,
      // });
      // if (statusData.status == "success") {
      //   toast.success("Precurement Initialized");
      //   setTimeout(() => {
      //     window.location.reload();
      //   }, 1000);
      // }
    } else if (status == 2) {
      const completedData = await precurement_completed({
        requirement_id: row.req_id,
        school_id: row.school_id,
      });
      if (completedData.status == "success") {
        toast.success("Precurement Completed");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  };
  const handleFundType = (e) => {
    setFundType(e.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleSubmit1 = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const formData = new FormData();
    const data = {
      amenities_id: invoiceData.amenities_id,
      fund_master_type_id: invoiceData.fundType === "generic" ? 1 : 2,
      fund_master_sub_type_id: invoiceData.fundSubType === "generic" ? 1 : 1,
      amenities_sub_type_id: invoiceData.amenities_sub_type_id,
      requirement_id: invoiceData.requirement_id,
      precurement_type: invoiceData.procurement.toString(),
      school_id: invoiceData.school_id,
    };

    // formData.append("amenities_id", invoiceData.amenities_id);
    // formData.append(
    //   "fund_master_type_id",
    //   invoiceData.fundType === "generic" ? 1 : 2
    // );
    // formData.append(
    //   "fund_master_sub_type_id",
    //   invoiceData.fundSubType === "generic" ? 1 : 1
    // );
    // formData.append("amenities_sub_type_id", invoiceData.amenities_sub_type_id);
    // formData.append("requirement_id", invoiceData.requirement_id);
    // formData.append("precurement_type", invoiceData.procurement.toString());
    // formData.append("school_id", invoiceData.school_id);

    try {
      const response = await precurementInitialization(data);
      if (response.status === "success") {
        toast.success("Submitted Successfully");
        setInvoiceData({
          fundType: "",
          fundSubType: "",
          initializeDate: "",
          requirement_id: "",
          amenities_id: "",
          amenities_sub_type_id: "",
          school_id: "",
          procurement: "",
        });
        setIsLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setIsLoading(false);
        toast.error(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error submitting data");
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const amount = invoiceData.amount || 0;
    const GST = invoiceData.GST || 0;
    const formData = new FormData();
    formData.append("amenities_id", invoiceData.amenities_id);
    formData.append(
      "fund_master_type_id",
      invoiceData.fundType === "generic" ? 1 : 2
    );
    formData.append(
      "fund_master_sub_type_id",
      invoiceData.fundSubType === "generic" ? 1 : 1
    );
    formData.append("amenities_sub_type_id", invoiceData.amenities_sub_type_id);
    formData.append("school_id", invoiceData.school_id);
    formData.append("actual_quantity", invoiceData.quantity);
    formData.append("actual_amount", amount);
    formData.append("fullfillment_date", invoiceData.deliveryDate.toString());
    formData.append("requirement_id", invoiceData.requirement_id);
    formData.append("gst", GST);
    formData.append("invoice_no", invoiceData.invoiceNumber);
    formData.append("total_amount", parseFloat(invoiceData.total));
    formData.append("precurement_type", invoiceData.procurement.toString());
    formData.append("confirm_delivery_dwo", invoiceData.confirm_delivery_dwo);
    formData.append(
      "upload_confirmed_delivery_asset_photo_dwo",
      invoiceData.upload_confirmed_delivery_asset_photo_dwo
    );

    try {
      const response = await confirmDeliveryDwo(formData);
      if (response.status === "success") {
        toast.success("Submitted Successfully");
        setInvoiceData({
          fundType: "",
          fundSubType: "",
          deliveryDate: "",
          invoiceNumber: "",
          quantity: "",
          GST: "",
          total: "",
          confirm_delivery_dwo: "",
          requirement_id: "",
          amenities_id: "",
          amenities_sub_type_id: "",
          school_id: "",
          procurement: "",
          upload_confirmed_delivery_asset_photo_dwo: "",
        });
        setIsLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        setIsLoading(false);
        toast.error(response);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error submitting data");
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCloseModal = () => {
    setnewModal(false);
  };
  const handleCloseModal1 = () => {
    setnewModal1(false);
  };
  const handleFulfillClick = (row) => {
    setnewModal(true);
    setIsShortage(row.is_shortage);

    setInvoiceData({
      ...invoiceData,
      requirement_id: row.req_id,
      amenities_id: row.amenity_id,
      amenities_sub_type_id: row.amenity_sub_type_id,
      school_id: row.school_id,
    });
  };
  const handleInitializeClick = (row) => {
    setnewModal1(true);
    setIsShortage(row.is_shortage);

    setInvoiceData({
      ...invoiceData,
      requirement_id: row.req_id,
      amenities_id: row.amenity_id,
      amenities_sub_type_id: row.amenity_sub_type_id,
      school_id: row.school_id,
    });
  };

  const getSerialNumber = (index) => {
    return page * rowsPerPage + index + 1;
  };

  //   useEffect(() => {
  //      const data ={
  //       fund_master_type_id: "",
  //       fund_master_sub_type_id:"",
  //      }

  //     fundMasterType(data)
  //         .then((response) => {
  //             if (response.status === "success") {
  //                 setFundTypes(response.data);
  //             } else {
  //                 setFundTypes([]);
  //             }
  //         })
  //         .catch((error) => {
  //             console.error("Error fetching fund types:", error);
  //             setFundTypes([]);
  //         });

  //     fundMasterSubType(data)
  //         .then((response) => {
  //             if (response.status === "success") {
  //                 setFundSubTypes(response.data);
  //             } else {
  //                 setFundSubTypes([]);
  //             }
  //         })
  //         .catch((error) => {
  //             console.error("Error fetching fund types:", error);
  //             setFundSubTypes([]);
  //         });
  // },);

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <h5 className="my-4">{t("Fulfillment")}</h5>
        <TableContainer
          component={Paper}
          style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
          className="my-4"
        >
          <Table aria-label="simple table" style={{ overflow: "scroll" }}>
            <TableHead>
              <TableRow>
                <TableCell align="center">{t("Sr No.")}</TableCell>
                <TableCell align="center">{t("School Name")}</TableCell>
                <TableCell align="center">{t("Amenity Type")}</TableCell>
                <TableCell align="center">{t("Amenity Sub Type")}</TableCell>
                <TableCell align="center">{t("Proposed Quantity")}</TableCell>
                <TableCell align="center">{t("Procurement Status")}</TableCell>
                <TableCell align="center">{t("Action")}</TableCell>
              </TableRow>
            </TableHead>
            {!isLoading && filteredData && filteredData.length > 0 && (
              <TableBody style={{ color: "white" }}>
                {filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">
                        {getSerialNumber(index)}
                      </TableCell>
                      <TableCell align="center">{row.school_name}</TableCell>
                      <TableCell align="center" style={{ width: "15%" }}>
                        {row.amenity_type}
                      </TableCell>
                      <TableCell align="center">{row.sub_type_name}</TableCell>
                      <TableCell align="center">{row.quantity}</TableCell>
                      <TableCell align="center">
                        {row.precurement_status}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() =>
                            row.precurement_status == "Not Initialized"
                              ? handleInitializeClick(row, 1)
                              : row.precurement_status == "Under Process"
                              ? handleProcurementStatusChange(row, 2)
                              : handleFulfillClick(row)
                          }
                        >
                          {row.precurement_status == "Not Initialized"
                            ? "Initialize"
                            : row.precurement_status == "Under Process"
                            ? "Complete"
                            : "Fulfill"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            )}
            {!isLoading && (!filteredData || filteredData.length === 0) && (
              <TableRow>
                <TableCell align="center" colSpan={7}>
                  <h4>
                    {" "}
                    <i>{t("No data available")}</i>{" "}
                  </h4>
                </TableCell>
              </TableRow>
            )}
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>

      {newModal && (
        <Modal
          open={newModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "relative",
              width: "90vw",
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
              marginTop: "14rem",
              margin: "5rem",
            }}
          >
            <h2 className="fw-bold text-center">{t("Fulfillment Details")}</h2>
            <button
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                right: "20px",
                top: "20px",
                border: "none",
                background: "none",
                fontSize: "1.5rem",
                cursor: "pointer",
              }}
            >
              &times;
            </button>
            <form onSubmit={handleSubmit}>
              <div className="my-4">
                <div className="row">
                  <div className="row">
                    {/* <div className="col">
                      <label>{t("Procurement Type")}</label>
                      <select
                        className="common-input form-select"
                        name="procurement"
                        onChange={handleInvoice}
                      >
                        <option>{t("Select Procurement Type")}</option>
                        <option value="Tender">{t("Tender")}</option>
                        <option value="Quotation">{t("Quotation")}</option>
                        <option value="EPM">{t("EPM")}</option>
                        <option value="GEM">{t("GEM Portal")}</option>
                        <option value="Other">{t("Other")}</option>
                      </select>
                    </div> */}
                    {/* <div className="col">
                      <label>{t("Fulfillment Date")}</label>
                      <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        onChange={handleInvoice}
                        name="deliveryDate"
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col">
                      <label>{t("Fund Type")}</label>
                      <input
                        type="text"
                        name="fundType"
                        onChange={handleInvoice}
                        value={isShortage === 0 ? "Generic" : "Additional"}
                        disabled
                        className="form-control"
                      />
                    </div> */}
                    {/* <div className="col">
                      <label>{t("Fund Sub-Type")}</label>
                      <input
                        name="fundSubType"
                        type="text"
                        onChange={handleInvoice}
                        value="Assets"
                        disabled
                        className="form-control"
                      />
                    </div> */}
                  </div>

                  <div className="row">
                    <div className="col">
                      <label>{t("Invoice Number")}</label>
                      <input
                        type="text"
                        onChange={handleInvoice}
                        name="invoiceNumber"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col">
                      <label>{t("Actual Quantity")}</label>
                      <input
                        type="text"
                        onChange={handleInvoice}
                        name="quantity"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col">
                      <label>{t("Amount")}</label>
                      <input
                        type="text"
                        onChange={handleInvoice}
                        name="amount"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col">
                      <label>{t("GST%")}</label>
                      <input
                        type="text"
                        onChange={handleInvoice}
                        name="GST"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col">
                      <label>{t("Total")}</label>
                      <input
                        type="number"
                        value={invoiceData.total}
                        name="total"
                        readOnly
                        className="form-control"
                      />
                    </div>
                    <div className="col">
                      <label>{t("Amenity Photo")}</label>
                      <input
                        type="file"
                        name="upload_confirmed_delivery_asset_photo_dwo"
                        accept="image/*"
                        className="form-control"
                        onChange={handleInvoice}
                      />
                    </div>
                    <div className="col">
                      <label>{t("Document")}</label>
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleInvoice}
                        name="confirm_delivery_dwo"
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col">
                      <label>{t("Fulfillment Date")}</label>
                      <input
                        type="date"
                        max={new Date().toISOString().split("T")[0]}
                        onChange={handleInvoice}
                        name="deliveryDate"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row d-flex mt-2">
                    <div className="col justify-content-center text-center">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        style={{ marginTop: "1rem" }}
                      >
                        {t("Submit")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </Modal>
      )}

      <Modal
        open={newModal1}
        onClose={handleCloseModal1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div
          style={{
            position: "relative",
            width: "90vw",
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: 8,
            padding: 20,
            marginTop: "14rem",
            margin: "5rem",
          }}
        >
          <h2 className="fw-bold text-center">{t("Initialization Details")}</h2>
          <button
            onClick={handleCloseModal1}
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              border: "none",
              background: "none",
              fontSize: "1.5rem",
              cursor: "pointer",
            }}
          >
            &times;
          </button>
          <form onSubmit={handleSubmit1}>
            <div className="my-4 col-12 mx-4">
              <div className="row">
                <div className="row">
                  <div className="col-3 ">
                    <label>{t("Procurement Type")}</label>
                    <select
                      className="common-input form-select"
                      name="procurement"
                      required
                      onChange={handleInvoice}
                    >
                      <option>{t("Select Procurement Type")}</option>
                      <option value="Tender">{t("Tender")}</option>
                      <option value="Quotation">{t("Quotation")}</option>
                      <option value="EPM">{t("EPM")}</option>
                      <option value="GEM">{t("GEM Portal")}</option>
                      <option value="Other">{t("Other")}</option>
                    </select>
                  </div>
                  <div className="col-3">
                    <label>{t("Initialization Date")}</label>
                    <input
                      type="date"
                      max={new Date().toISOString().split("T")[0]}
                      onChange={handleInvoice}
                      name="initializeDate"
                      className="form-control"
                    />
                  </div>
                  <div className="col-2">
                    <label>{t("Fund Type")}</label>
                    <input
                      type="text"
                      name="fundType"
                      onChange={handleInvoice}
                      value={isShortage === 0 ? "Generic" : "Additional"}
                      disabled
                      className="form-control"
                    />
                  </div>
                  <div className="col-2">
                    <label>{t("Fund Sub-Type")}</label>
                    <input
                      name="fundSubType"
                      type="text"
                      onChange={handleInvoice}
                      value="Assets"
                      disabled
                      className="form-control"
                    />
                  </div>
                  <div className="col-2">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      style={{ marginTop: "1.5rem", width: "10rem" }}
                    >
                      {t("Submit")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default Fulfillment;
